import {createBaloonTemplate} from '../../GoogleMaps/functions/createBaloonTemplate';

export class PropertyCardBalloon {
    constructor(bus) {
        this.bus = bus;
    }

    /**
     * Retrieves the outer HTML property card element for the specified property ID.
     *
     * @param propertyUuid {string}
     * @returns {string}
     */
    retrieveHtml(property, isVisible = true) {
        let template = createBaloonTemplate(property, isVisible);
        let htmlElem = '';

        if (template) {
            let child = document.createElement('div');
            child.innerHTML = template;
            let newElem = document.createElement('div');

            newElem.setAttribute('class', 'property-listing property-listing-card-balloon');
            newElem.appendChild(child);

            let childElem = newElem.firstElementChild;
            childElem.setAttribute('class', 'property-listing-card');

            this.displayButtonIconOnly(childElem);

            htmlElem = newElem.outerHTML;
        }

        return htmlElem;
    }

    /**
     * Displays only the icon of the button <br>
     * *div[data-displayButtonIconOnly="true"]*
     *
     * @param elem {Element}
     */
    displayButtonIconOnly(elem) {
        let buttonElements = elem.querySelectorAll('div[data-displayButtonIconOnly="true"]');

        buttonElements.forEach(buttonElem => {
            let button = buttonElem.getElementsByTagName('button')[0].firstChild;

            if (typeof button === "undefined") {
                return;
            }

            let attributes = button.attributes.class.nodeValue;
            let node = document.createElement('i');
            buttonElem.removeChild(buttonElem.firstChild);

            if (typeof attributes !== 'undefined') {
                node.setAttribute('class', attributes.replace(/(btn)+[-a-zA-Z]*/g, ''));
            }

            buttonElem.appendChild(node);
        });
    }
}
